<template>
  <div id="app">
      <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #fff;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
#share_wrapper{
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  top:0;
  right: 0;
  z-index: 0;
}
#share_wrapper1{
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0;
  left: 0;
  top:0;
  right: 0;
  z-index: -1;
}
.public_width{
  width: 690px;
  margin: 0 auto;
}
input{
  border: none;
  height: auto;
  width: auto;
}
.borderLine{
  height: 20px;
  background: #F1F1F1;
  width: 750px;
  margin: 0 auto;
}
.bg{
    width: 750px;
    margin: 0 auto;
    border-top: 1px solid transparent;
    background: #302C6F url("../static/img/bg.jpg")no-repeat;
    background-size: 750px 829px;
    background-attachment:fixed;
    background-position: bottom;
}
.noscroll{
    position: absolute; 
    height: 100%;
    overflow: hidden;
    width: 750px;
    left: 50%;
    margin-left: -375px; 
    /* margin: 0 auto; */
    border-top: 1px solid transparent;
    background: #302C6F url("../static/img/bg.jpg")no-repeat;
    background-size: 750px 829px;
    background-attachment:fixed;
    background-position: bottom;
    z-index: 0;
}
.bottom{
    background:#302C6F  url("../static/img/bg.jpg")no-repeat bottom;
    background-size: 750px 829px;
    height: 100%;
    width: 750px;
    position: absolute;
    bottom:0;
    left: 50%;
    margin-left: -375px; 
    z-index: -1;
}
[contenteditable = "true"], input, textarea {
    -webkit-user-select: auto!important;
    -khtml-user-select: auto!important;
    -moz-user-select: auto!important;
    -ms-user-select: auto!important;
    -o-user-select: auto!important;
    user-select: auto!important;
}

.bubbly-button {
  cursor: pointer;
  position: relative;
  transition: transform ease-in 0.1s, box-shadow ease-in 0.25s;
  /* box-shadow: 0 2px 25px rgba(255, 0, 130, 0.5); */
}
.bubbly-button:focus {
  outline: 0;
}
.bubbly-button:before, .bubbly-button:after {
  position: absolute;
  content: '';
  display: block;
  width: 140%;
  height: 100%;
  left: -10%;
  z-index: -1000;
  transition: all ease-in-out 0.5s;
  background-repeat: no-repeat;
}
.bubbly-button:before {
  display: none;
  top: -65%;
  background-image: radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, transparent 20%, #DEB837 20%, transparent 30%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, transparent 10%, #DEB837 15%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #ff0081 20%, transparent 20%);
  background-size: 10% 10%, 20% 20%, 15% 15%, 20% 20%, 18% 18%, 10% 10%, 15% 15%, 10% 10%, 18% 18%;
}
.bubbly-button:after {
  display: none;
  bottom: -65%;
  background-image: radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, transparent 10%, #DEB837 15%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%), radial-gradient(circle, #DEB837 20%, transparent 20%);
  background-size: 15% 15%, 20% 20%, 18% 18%, 20% 20%, 15% 15%, 10% 10%, 20% 20%;
}
.bubbly-button:active {
  transform: scale(0.9);
  background-color: #DEB837;
  box-shadow: 0 2px 25px rgba(255, 0, 130, 0.2);
}
.bubbly-button.animate:before {
  display: block;
  animation: topBubbles ease-in-out 0.75s forwards;
}
.bubbly-button.animate:after {
  display: block;
  animation: bottomBubbles ease-in-out 0.75s forwards;
}

@keyframes topBubbles {
  0% {
    background-position: 5% 90%, 10% 90%, 10% 90%, 15% 90%, 25% 90%, 25% 90%, 40% 90%, 55% 90%, 70% 90%;
  }
  50% {
    background-position: 0% 80%, 0% 20%, 10% 40%, 20% 0%, 30% 30%, 22% 50%, 50% 50%, 65% 20%, 90% 30%;
  }
  100% {
    background-position: 0% 70%, 0% 10%, 10% 30%, 20% -10%, 30% 20%, 22% 40%, 50% 40%, 65% 10%, 90% 20%;
    background-size: 0% 0%, 0% 0%,  0% 0%,  0% 0%,  0% 0%,  0% 0%;
  }
}
@keyframes bottomBubbles {
  0% {
    background-position: 10% -10%, 30% 10%, 55% -10%, 70% -10%, 85% -10%, 70% -10%, 70% 0%;
  }
  50% {
    background-position: 0% 80%, 20% 80%, 45% 60%, 60% 100%, 75% 70%, 95% 60%, 105% 0%;
  }
  100% {
    background-position: 0% 90%, 20% 90%, 45% 70%, 60% 110%, 75% 80%, 95% 70%, 110% 10%;
    background-size: 0% 0%, 0% 0%,  0% 0%,  0% 0%,  0% 0%,  0% 0%;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue